// extracted by mini-css-extract-plugin
export default {"faqHeader":"Faq_faqHeader__nt9PB","faqContent":"Faq_faqContent__gB1HD"};